export default __webpack_public_path__ + "static/media/infobbok_white.6c71240d.svg";